import "./Footer.css";
import { Link } from 'react-router-dom';
import HomeIcon from '@mui/icons-material/Home';
import CallIcon from '@mui/icons-material/Call';
import MailIcon from '@mui/icons-material/Mail';
import LocationIcon from '@mui/icons-material/LocationOn';
const Footer = () => {
    return (
        <footer className="footerHeader">
            <div className="footerContent">
                <div className="footerBrand">
                    <span className="font-weight-bold fontColor headerTitle">Lé Heaven Inn</span>
                    <p className="fontColor footerBlurb">
                        Lé Heaven Inn is a luxurious and tranquil retreat offering an ideal escape with stunning views and top-notch amenities. Relax by the private pool or unwind in spacious rooms while enjoying attentive service.
                    </p>
                </div>
                <div className="footerContact">
                    <span className="font-weight-bold fontColor headerTitle">Have a Questions ?</span>
                    <div className="footerContactItem">
                        <LocationIcon className="fontColor" />
                        <div>
                            7th cross, Universal Form House,<br />Auroville road,<br />Villupuram - 605111
                        </div>
                    </div>
                    <div className="footerContactItem">
                        <CallIcon className="fontColor" />
                        <div>
                            9600201004<br />
                            8778193692
                        </div>
                    </div>
                    <div className="footerContactItem">
                        <MailIcon className="fontColor" />
                        <div>heavenvilla5353@gmail.com</div>
                    </div>
                </div>
                <div className="footerExtras">
                    <span className="font-weight-bold fontColor headerTitle">Plan your stay</span>
                    <ul>
                        <li>Check availability</li>
                        <li>View gallery</li>
                        <li>Browse amenities</li>
                    </ul>
                </div>
            </div>
            <div className="footerCredit">
                <p>
                    © 2025 Lé Heaven Inn | All rights reserved. | Designed By{' '}
                    <a href="https://www.webglotechnology.in" target="_blank" rel="noreferrer">
                        Webglo Technology
                    </a>
                </p>
            </div>
        </footer>
    )
}

export default Footer;